import { render, staticRenderFns } from "./ReviewQuestions.vue?vue&type=template&id=2b5880c1&"
import script from "./ReviewQuestions.vue?vue&type=script&lang=ts&"
export * from "./ReviewQuestions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports